import React, { useEffect, useRef } from "react";
import { WeatherHelper } from "../../../utils/weather/WeatherHelper";
import compassBig from "../images/compass_big.svg";
import compassSmall from "../images/compass_small.svg";

export interface IDirectionCompassProps {
  degree: number;
  canvasId?: string;
  size?: "small" | "big";
  runwayImg?: string;
  headDegree: number;
}
export const DirectionCompass: React.FC<IDirectionCompassProps> = ({
  degree,
  headDegree,
  canvasId,
  size = "big",
  runwayImg,
}) => {
  const canvasRef = useRef<HTMLCanvasElement | null>(null);
  const canvasCtxRef = React.useRef<CanvasRenderingContext2D | null>(null);
  const compassImgRef = useRef<HTMLImageElement | null>(null);
  const runwayImgRef = useRef<HTMLImageElement | null>(null);
  let ctx: any;
  let img: any;
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    canvasCtxRef.current = canvas.getContext("2d");
    ctx = canvasCtxRef.current;
    const compassImg = new Image();
    compassImg.src = size === "big" ? compassBig : compassSmall;
    compassImg.onload = () => {
      compassImgRef.current = compassImg;
      draw();
    };
  }, [size]);

  useEffect(() => {
    if (!runwayImg) return;

    const img = new Image();
    img.src = runwayImg;
    img.onload = () => {
      runwayImgRef.current = img;
      draw();
    };
  }, [runwayImg]);

  useEffect(() => {
    draw();
  }, [degree, headDegree]);

  const draw = () => {
    const ctx = canvasCtxRef.current;
    const compassImg = compassImgRef.current;
    const runwayImage = runwayImgRef.current;

    if (!ctx || !compassImg || !runwayImage) return;

    WeatherHelper.setWindDirection(degree, ctx, compassImg);
    WeatherHelper.setRunwayDirection(headDegree, ctx, runwayImage);
  };

  return (
    <div className="pt-2" data-testid="direction-compass">
      <canvas
        id={canvasId}
        ref={canvasRef}
        height={size === "big" ? 266 : 200}
        width={size === "big" ? 266 : 200}
      />
    </div>
  );
};
